var Preconditions = require('./Preconditions.js'); 
var _ = require('lodash');

function BlobMetaData(json)
{
    this.data = _.cloneDeep(json);
}
BlobMetaData.prototype.getOrganizationAccountId = function() { return this.data.organization_id; }
BlobMetaData.prototype.getOrganizationId = function() { return this.data.organization_id; }
BlobMetaData.prototype.getBlobId = function() { return this.data.blob_id; }
BlobMetaData.prototype.getUploadedByEmployeeAccountId = function() { return this.data.uploaded_by_employee_id; }
BlobMetaData.prototype.getUploadedByEmployeeId = function() { return this.data.uploaded_by_employee_id; }
BlobMetaData.prototype.getPurpose = function() { return this.data.purpose; }
BlobMetaData.prototype.isArchived = function() { return this.data.is_archived; }
BlobMetaData.prototype.getUploadedTime = function() { return this.data.uploaded_time; }
BlobMetaData.prototype.getSizeInBytes = function() { return this.data.size_in_bytes; }
BlobMetaData.prototype.getContentType = function() { return this.data.content_type; }
BlobMetaData.prototype.getLabel = function() { return this.data.label; }
BlobMetaData.prototype.getNaturalFileName = function() { return this.data.natural_filename; }
BlobMetaData.prototype.isImage = function() { return this.data.content_type.startsWith('image/'); }
BlobMetaData.prototype.isQuicktimeMovie = function() { return this.data.content_type.startsWith('video/quicktime'); }
BlobMetaData.prototype.isProcessingPending = function() { return this.data.processing == 'pending' }
BlobMetaData.prototype.isProcessingComplete = function() { return this.data.processing == 'complete' }
BlobMetaData.prototype.isProcessingFailed = function() { return this.data.processing == 'failed' }
BlobMetaData.prototype.getObjectName = function() { return this.data.object_name; }
BlobMetaData.prototype.getRestrictToIndustryCode = function() { return this.data.restrict_to_industry_code; }

BlobMetaData.prototype.getFileIcon = function()
{
    let content_type = this.getContentType();

    if ( content_type === 'application/pdf' ) return "mdi-file-pdf-box";
    if ( content_type === 'text/css' ) return "mdi-cloud-braces";
    if ( content_type === 'application/javascript' ) return "mdi-file-code";
    if ( content_type === 'text/html' ) return "mdi-file-code";
    if ( content_type === 'text/xml' ) return "mdi-file-code";
    if ( content_type === 'text/markdown' ) return "mdi-file-code";
    if ( content_type === 'text/csv' ) return "mdi-file-code";
    if ( content_type === 'application/json' ) return "mdi-file-code";
    if ( content_type === 'application/xhtml+xml' ) return "mdi-file-code";

    if ( content_type === 'text/plain' ) return "mdi-file-document-outline";

    if ( content_type === 'application/msword' ) return "mdi-file-word-outline";
    if ( content_type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ) return "mdi-file-word-outline";
	
    if ( content_type === 'audio/midi' ) return "mdi-file-music-outline";
    if ( content_type === 'audio/mpeg' ) return "mdi-file-music-outline";
    if ( content_type === 'audio/wav' ) return "mdi-file-music-outline";

    if ( content_type === 'video/mpeg' ) return "mdi-file-video-outline";
    if ( content_type === 'video/mp4' ) return "mdi-file-video-outline";
    if ( content_type === 'video/quicktime' ) return "mdi-file-video-outline";
	
    if ( content_type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ) return "mdi-file-powerpoint-outline";
    
    if ( content_type === 'application/rtf' ) return "mdi-file-document-outline";

    if ( content_type === 'application/vnd.ms-excel' ) return "mdi-file-excel-outline";
    if ( content_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ) return "mdi-file-excel-outline";

    return "mdi-file-outline";
}

module.exports = BlobMetaData;

/*
{
    "organization_id" : "00000000-0000-0000-0000-000000000000",
    "blob_id" : "00000000-0000-0000-0000-000000000001",
    "uploaded_by_employee_id" : "00000000-0000-0000-0000-000000000002",
    "purpose" : "attachment",
    "is_archived" : true,
    "uploaded_time" : 5,
    "size_in_bytes" : 6,
    "content_type" : "image/jpeg",
    "label" : "some-string-8",
    "natural_filename" : "some-string-8.jpg"
  }
*/